import { ButtonTriggerEvent } from '../../../../common/components';
import { Account } from '../../../../models/admin/account';

export class ShowPlacesCountModalActions {
    confirm: (event: ButtonTriggerEvent) => void;
    cancel?: () => void;
}

export class ShowPlacesCountModalData {
    account: Account;
    constructor(account?) {
        this.account = account;
    }
}


// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/components/admin/accounts/show.places.count/show.places.count.modal.provider.ts